<div class="cond-select" [class.cond-select--disabled]="disabled">
  <div
    #triggerRef
    class="cond-select__trigger"
    [class.cond-select__trigger--open]="isOpen"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="listbox"
    (click)="toggle($event)"
  >
    <i class="fas fa-search cond-select__trigger-icon" *ngIf="!condicaoSelecionada || isOpen"></i>

    <input
      #searchInputRef
      *ngIf="isOpen"
      type="text"
      class="cond-select__search-input"
      aria-label="Buscar condição de pagamento"
      [(ngModel)]="searchTerm"
      (ngModelChange)="indiceAtivo = condicoesFiltradas.length ? 0 : -1"
      (keydown)="onKeydown($event)"
      (click)="$event.stopPropagation()"
    />

    <ng-container *ngIf="!isOpen">
      <span class="cond-select__label" *ngIf="condicaoSelecionada; else placeholderTpl">
        <span class="cond-select__label-text">{{ condicaoSelecionada.nome }}</span>
        <span class="cond-select__label-meta">
          início {{ condicaoSelecionada.prazoInicial }}d · {{ condicaoSelecionada.quantidadeParcelas }}x · múlt. {{ condicaoSelecionada.multiplo }}
        </span>
      </span>
      <ng-template #placeholderTpl>
        <span class="cond-select__placeholder">Buscar por nome ou prazos (ex.: 30/60/90)…</span>
      </ng-template>
    </ng-container>

    <span class="cond-select__actions">
      <span
        *ngIf="condicaoSelecionada && !disabled"
        class="cond-select__clear"
        role="button"
        title="Remover condição selecionada"
        (click)="limpar($event)"
      >
        <i class="fas fa-times"></i>
      </span>
      <i
        class="fas cond-select__chevron"
        [ngClass]="{
          'fa-chevron-up': isOpen,
          'fa-chevron-down': !isOpen
        }"
      ></i>
    </span>
  </div>

  <div class="cond-select__panel" *ngIf="isOpen" [ngStyle]="dropdownStyle">
    <div class="cond-select__legend">
      <span class="cond-select__legend-title">Legenda:</span>
      <span><i class="fas fa-hourglass-start"></i> Prazo inicial</span>
      <span><i class="fas fa-list-ol"></i> Parcelas</span>
      <span><i class="fas fa-arrows-alt-h"></i> Múltiplo (dias entre parcelas)</span>
      <span><i class="fas fa-chart-line"></i> Prazo médio</span>
    </div>

    <div class="cond-select__loading" *ngIf="isLoading">
      <i class="fas fa-spinner fa-spin"></i> Carregando…
    </div>

    <div #listRef class="cond-select__list" *ngIf="!isLoading">
      <ng-container *ngIf="condicoesFiltradas.length; else vazioTpl">
        <ng-container *ngFor="let grupo of grupos">
          <div class="cond-select__group-header">
            <i class="fas fa-arrows-alt-h" *ngIf="grupo.multiplo"></i>
            {{ multiploLabel(grupo.multiplo) }}
          </div>
          <button
            type="button"
            *ngFor="let condicao of grupo.condicoes"
            class="cond-row"
            [class.cond-row--selected]="condicaoSelecionada?.id === condicao.id"
            [class.cond-row--ativa]="isItemAtivo(condicao)"
            [attr.data-selected]="condicaoSelecionada?.id === condicao.id ? '' : null"
            [attr.data-ativo]="isItemAtivo(condicao) ? '' : null"
            (mousedown)="selecionar(condicao, $event)"
          >
            <span class="cond-row__check" [class.cond-row__check--selected]="condicaoSelecionada?.id === condicao.id">
              <i class="fas fa-check" *ngIf="condicaoSelecionada?.id === condicao.id"></i>
            </span>
            <span class="cond-row__body">
              <span class="cond-row__name">{{ condicao.nome }}</span>
              <span class="cond-row__meta">
                <span class="cond-row__meta-item">
                  <i class="fas fa-hourglass-start"></i>
                  <strong>{{ condicao.prazoInicial }}</strong>
                  <span class="cond-row__meta-unit">d</span>
                </span>
                <span class="cond-row__meta-sep">·</span>
                <span class="cond-row__meta-item">
                  <i class="fas fa-list-ol"></i>
                  <strong>{{ condicao.quantidadeParcelas }}</strong>
                  <span class="cond-row__meta-unit">×</span>
                </span>
                <span class="cond-row__meta-sep">·</span>
                <span class="cond-row__meta-item">
                  <i class="fas fa-arrows-alt-h"></i>
                  <strong>{{ condicao.multiplo }}</strong>
                </span>
                <span class="cond-row__meta-sep">·</span>
                <span class="cond-row__meta-item">
                  <i class="fas fa-chart-line"></i>
                  <strong>{{ condicao.prazoMedio }}</strong>
                  <span class="cond-row__meta-unit">d</span>
                </span>
              </span>
            </span>

            <span class="cond-row__tag cond-row__tag--cliente" *ngIf="isCliente(condicao)">
              <i class="fas fa-user-lock"></i> Cliente
            </span>
            <span class="cond-row__tag cond-row__tag--ativa" *ngIf="isAtiva(condicao)">
              <i class="fas fa-check-circle"></i> Ativa
            </span>
            <span class="cond-row__tag cond-row__tag--inativa" *ngIf="isInativa(condicao)">
              <i class="fas fa-ban"></i> Inativa
            </span>
          </button>
        </ng-container>
      </ng-container>

      <ng-template #vazioTpl>
        <div class="cond-select__empty">
          <i class="far fa-folder-open"></i>
          <p>Nenhuma condição encontrada.</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
